import React, { useEffect, useState } from "react";
import { createLeaveEmployee, getUserLeaves } from "../../../service/leavesEmployeeApiService";
import { getAllEmployeesMethod, getDepartmentById } from "../../../service/ApiServices";
import { getAllHolidays } from "../../../service/holidayService.js";
import { getEmployeeByUserId } from "../../../service/employeeService";
import Select from "react-select";
import PropTypes from "prop-types";
import { notification } from "antd";

const AddLeaveEmployee = ({ handleCancel, FetchLeaveEmployees }) => {
  const leaveDayOptions = [
    { value: "FULL DAY", label: "Full Day", dayValue: 1 },
    { value: "FIRST HALF", label: "First Half", dayValue: 0.5 },
    { value: "SECOND HALF", label: "Second Half", dayValue: 0.5 },
  ];

  const [dateRange, setDateRange] = useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [shortLeave, setShortLeave] = useState(false);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [reason, setReason] = useState("");
  const [leaveDays, setLeaveDays] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [dutyLeave, setDutyLeave] = useState(false);
  const [specialLeave, setSpecialLeave] = useState(false);
  const [regularLeave, setRegularLeave] = useState(true);
  const [maternityLeave, setMaternityLeave] = useState(false);
  const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(null);
  const [currentDate] = useState(new Date());
  const [viewMonth, setViewMonth] = useState(currentDate.getMonth());
  const [viewYear, setViewYear] = useState(currentDate.getFullYear());
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedCoverupEmployee, setSelectedCoverupEmployee] = useState(null);
  const [documentFile, setDocumentFile] = useState(null);
  const [isFemale, setIsFemale] = useState(false);
  const [isNonAcademicEmployee, setIsNonAcademicEmployee] = useState(false);
  const [isDepartmentCoverupEnabled, setIsDepartmentCoverupEnabled] = useState(null);
  const [userDepartmentId, setUserDepartmentId] = useState(null);
  const [holidays, setHolidays] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const shortLeaveOptions = [
    { value: "Clock In", label: "Clock In" },
    { value: "Clock Out", label: "Clock Out" },
  ];

  const resetForm = () => {
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setDateRange([]);
    setSelectedLeaveType(null);
    setReason("");
    setLeaveDays([]);
    setShortLeave(false);
    setSelectedTime(null);
    setDutyLeave(false);
    setSpecialLeave(false);
    setRegularLeave(false);
    setMaternityLeave(false);
    setExpectedDeliveryDate(null);
    setSelectedCoverupEmployee(null);
    setDocumentFile(null);
  };

  useEffect(() => {
    fetchLeaveTypes();
    fetchEmployeeData();
    fetchHolidays();
    // fetchEmployees will be called separately when userDepartmentId is set
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Fetch employees when userDepartmentId is available
  useEffect(() => {
    fetchEmployees();
  }, [userDepartmentId]); // eslint-disable-line react-hooks/exhaustive-deps
  
const fetchLeaveTypes = async () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.data._id;
    const response = await getUserLeaves(userId);
    const leaveTypeData = response.leaveBalances;
    if (leaveTypeData) {
      const options = leaveTypeData
        .filter((leave) => leave.currentBalance > 0)
        .map((leave) => ({
          value: leave.leaveType._id,
          label: leave.leaveType.name,
          leaveCount: leave.currentBalance,
        }));
      setLeaveType([{ value: "Choose", label: "Choose" }, ...options]);
    }
  } catch (error) {
    console.error("Error fetching leave types:", error);
  }
};

  const showNotification = (type, message, description) => {
    api[type]({
      message,
      description,
      placement: 'topRight',
      duration: 4.5,
    });
  };

  const fetchDepartmentData = async (departmentId) => {
    try {
      if (!departmentId) {
        setIsDepartmentCoverupEnabled(false);
        return;
      }
      const response = await getDepartmentById(departmentId);
      if (response.status === "success" && response.data?.department) {
        setIsDepartmentCoverupEnabled(response.data.department.isCoverup ?? false);
      } else {
        setIsDepartmentCoverupEnabled(false);
      }
    } catch (error) {
      console.error("Error fetching department data:", error.message);
      setIsDepartmentCoverupEnabled(false);
    }
  };

  const fetchEmployeeData = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.data._id;
      const response = await getEmployeeByUserId(userId);
      if (response.status === 200 && response.data.data) {
        setIsFemale(response.data.data.gender?.toLowerCase() === "female");
        setUserDepartmentId(response.data.data.department_id);
        const employeeType = response.data.data.employee_type;
        setIsNonAcademicEmployee(
          typeof employeeType === "string" &&
            employeeType.toLowerCase() === "non academic"
        );
        if (response.data.data.department_id) {
          await fetchDepartmentData(response.data.data.department_id);
        } else {
          setIsDepartmentCoverupEnabled(false);
        }
      } else {
        setIsFemale(false);
        setUserDepartmentId(null);
        setIsDepartmentCoverupEnabled(false);
        setIsNonAcademicEmployee(false);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setIsFemale(false);
      setUserDepartmentId(null);
      setIsDepartmentCoverupEnabled(false);
      setIsNonAcademicEmployee(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      await getAllEmployeesMethod({
        setEmployeeData: (data) => {
          setEmployees(data);
          if (userDepartmentId) {
            const filtered = data.data?.filter(
              (emp) => emp.department_id?.toString() === userDepartmentId?.toString()
            ) || [];
            setFilteredEmployees(filtered);
            // console.log("Filtered Employees:", filtered);
            // console.log("UserDepartmentId:", userDepartmentId);
            // console.log("Sample employee dept:", data.data?.[0]?.department_id);
          } else {
            setFilteredEmployees(data.data || []);
            // console.log("No userDepartmentId, showing all employees:", data.data);
          }
          // console.log("data Employees:", data);
        },
        setLoading: () => {},
        params: { page: 1, limit: 1000 },
        search: "",
      });
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchHolidays = async () => {
    try {
      await getAllHolidays({
        search: "",
        setData: (data) => {
          setHolidays(data);
        },
      });
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };

  useEffect(() => {
    if (userDepartmentId && employees.data) {
      const filtered = employees.data.filter(
        (emp) => emp.department_id?.toString() === userDepartmentId?.toString()
      );
      setFilteredEmployees(filtered);
      console.log("UseEffect - Filtered Employees:", filtered);
      console.log("UseEffect - UserDepartmentId:", userDepartmentId);
    }
  }, [userDepartmentId, employees]);

  const formatDate = (date) => {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  };

  const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (month, year) => {
    return new Date(year, month, 1).getDay();
  };
const isDateDisabled = (date, selectedLeaveTypeValue = "FULL DAY") => {
  // Check cutoff date
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  let prevMonth = currentMonth - 1;
  let prevYear = currentYear;
  if (prevMonth < 0) {
    prevMonth = 11;
    prevYear -= 1;
  }
  const cutoffDate = new Date(prevYear, prevMonth, 19);
  cutoffDate.setHours(0, 0, 0, 0);

  if (date < cutoffDate) return true;

  // Get current user and employee type
  const user = JSON.parse(localStorage.getItem("user"));
  const isAcademic = employees.data?.find(emp => emp.user === user?.data._id)?.employee_type === "Academic";
  
  // Disable Saturdays for Academic employees
  const isSaturday = date.getDay() === 6;
  if (isAcademic && isSaturday) return true;

  // Check Sundays and holidays for regular leaves
  if (regularLeave || dutyLeave || shortLeave || specialLeave) {
    console.log("Inside Check Holidays and Sundays")
    const dateStr = formatDate(date);
    const isSunday = date.getDay() === 0;
    if (isSunday) return true;

    const matchingHolidays = holidays.filter(h =>
        h.daysDetail.some(d =>
            d.day !== "Flexible" &&
            formatDate(new Date(d.date)) === dateStr
        )
    );
    console.log("Matching Holidays",matchingHolidays)
    for (const holiday of matchingHolidays) {
      // Check if holiday applies to current employee type
      const holidayAppliesToEmployee = 
        !holiday.holidayType || 
        holiday.holidayType === "Common" ||
        (holiday.holidayType === "Academic" && isAcademic) ||
        (holiday.holidayType === "Non Academic" && !isAcademic);
        
      if (!holidayAppliesToEmployee) {
        continue; // Skip this holiday as it doesn't apply to current employee
      }

      for (const dayDetail of holiday.daysDetail) {
        if (formatDate(new Date(dayDetail.date)) === dateStr) {
          // Check for full day holidays
          if (["Full Day", "Flexible"].includes(dayDetail.day)) {
            return true;
          }
          
          // Check for half day conflicts
          if (selectedLeaveTypeValue === "FIRST HALF" && dayDetail.day === "Half Day-Morning") {
            return true;
          }
          
          if (selectedLeaveTypeValue === "SECOND HALF" && dayDetail.day === "Half Day-Evening") {
            return true;
          }
          
          // For full day leave on half day holiday, allow selection (will be adjusted)
          if (selectedLeaveTypeValue === "FULL DAY" && 
              ["Half Day-Morning", "Half Day-Evening"].includes(dayDetail.day)) {
            return false; // Allow selection, will adjust to available half
          }
        }
      }
    }
  }

  return false;
};

  const isDateInRange = (date) => {
    if (!selectedStartDate || !selectedEndDate) return false;
    return date >= selectedStartDate && date <= selectedEndDate;
  };

  const isSelectedDate = (date) => {
    if (!selectedStartDate && !selectedEndDate && !expectedDeliveryDate) return false;
    return (
      (selectedStartDate && date.getTime() === selectedStartDate.getTime()) ||
      (selectedEndDate && date.getTime() === selectedEndDate.getTime()) ||
      (expectedDeliveryDate && date.getTime() === expectedDeliveryDate.getTime())
    );
  };

  const calculateMaternityDates = (deliveryDate) => {
    const expectedDate = new Date(deliveryDate);
    if (isNaN(expectedDate.getTime())) return { startDate: null, endDate: null };
    const startDate = new Date(expectedDate);
    startDate.setDate(expectedDate.getDate() - 14);
    let workingDaysCount = 0;
    let currentDate = new Date(startDate);
    let endDate = null;
    while (workingDaysCount < 84) {
      currentDate.setDate(currentDate.getDate() + 1);
      const dayOfWeek = currentDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        workingDaysCount++;
      }
      if (workingDaysCount === 84) {
        endDate = new Date(currentDate);
      }
    }
    return { startDate, endDate };
  };

  useEffect(() => {
    if (maternityLeave && expectedDeliveryDate) {
      const { startDate, endDate } = calculateMaternityDates(expectedDeliveryDate);
      if (startDate && endDate) {
        setSelectedStartDate(startDate);
        setSelectedEndDate(endDate);
        const daysArray = [];
        let currentDate = new Date(startDate);
        while (currentDate <= endDate) {
          daysArray.push({
            date: formatDate(new Date(currentDate)),
            Day: "FULL DAY",
            dayValue: 1,
          });
          currentDate.setDate(currentDate.getDate() + 1);
        }
        setLeaveDays(daysArray);
        setDateRange(daysArray.map(day => ({
          day: `Day ${daysArray.indexOf(day) + 1}`,
          date: day.date,
          leaveType: day.Day,
        })));
      }
    } else if (!maternityLeave) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      setDateRange([]);
      setLeaveDays([]);
      setExpectedDeliveryDate(null);
    }
  }, [expectedDeliveryDate, maternityLeave]);

const handleDateClick = (date) => {
  if (maternityLeave) {
    setExpectedDeliveryDate(date);
    return;
  }

  const user = JSON.parse(localStorage.getItem("user"));
  const isAcademic = employees.data?.find(emp => emp.user === user?.data._id)?.employee_type === "Academic";
  const isSaturday = date.getDay() === 6;

  if (isAcademic && isSaturday) {
    showNotification('warning', 'Invalid Date', 'Saturdays are not available for leave for Academic employees.');
    return;
  }

  if (shortLeave) {
    if (isDateDisabled(date, "FULL DAY")) {
      showNotification('warning', 'Invalid Date', 'You cannot select holidays or Sundays for short leaves.');
      return;
    }
    setSelectedStartDate(date);
    setSelectedEndDate(date);
    const singleDayArray = [{
      day: "Day 1",
      date: formatDate(date),
      leaveType: "FULL DAY",
      dayValue: 1,
    }];
    setDateRange(singleDayArray);
    setLeaveDays([{
      date: formatDate(date),
      Day: "FULL DAY",
      dayValue: 1,
    }]);
    return;
  }

  const selectedLeaveTypeValue = leaveDays.length > 0 ? leaveDays[0].Day : "FULL DAY";

  if (isDateDisabled(date, selectedLeaveTypeValue)) {
    showNotification('warning', 'Invalid Date', 'You cannot select holidays or Sundays for regular leaves.');
    return;
  }

  // Handle start date selection or range reset
  if (!selectedStartDate || (selectedStartDate && selectedEndDate)) {
    setSelectedStartDate(date);
    setSelectedEndDate(null);
    setDateRange([]);
    setLeaveDays([]);
    return; // Don't process range yet, wait for end date
  } 
  
  // Handle end date selection
  if (selectedStartDate && !selectedEndDate) {
    let startDate = selectedStartDate;
    let endDate = date;
    
    // Ensure start date is before end date
    if (date < selectedStartDate) {
      startDate = date;
      endDate = selectedStartDate;
    }
    
    setSelectedStartDate(startDate);
    setSelectedEndDate(endDate);

    const daysArray = [];
    const leaveDaysArray = [];
    let dayCount = 1;
    let currentDate = new Date(startDate);

    // Process each date in the range
    while (currentDate <= endDate) {
      const dateStr = formatDate(currentDate);
      const isSunday = currentDate.getDay() === 0;
      const isSaturday = currentDate.getDay() === 6;
      
      // Check if this specific date should be excluded
      let shouldIncludeDate = true;
      
      // Skip Sundays for all leave types
      if (isSunday) {
        shouldIncludeDate = false;
      }
      
      // Skip Saturdays for Academic employees
      if (isAcademic && isSaturday) {
        shouldIncludeDate = false;
      }
      
      // Check holidays for this specific date and employee type
      let effectiveLeaveType = selectedLeaveTypeValue;
      
      if (shouldIncludeDate && (regularLeave || dutyLeave || specialLeave)) {
        const matchingHolidays = holidays.filter(h =>
          h.daysDetail.some(d => formatDate(new Date(d.date)) === dateStr)
        );

        for (const holiday of matchingHolidays) {
          // Check if holiday applies to current employee type
          const holidayAppliesToEmployee = 
            !holiday.holidayType || 
            holiday.holidayType === "Common" ||
            (holiday.holidayType === "Academic" && isAcademic) ||
            (holiday.holidayType === "Non Academic" && !isAcademic);
            
          if (!holidayAppliesToEmployee) {
            continue; // Skip this holiday as it doesn't apply to current employee
          }

          for (const dayDetail of holiday.daysDetail) {
            if (formatDate(new Date(dayDetail.date)) === dateStr) {
              console.log("Holiday in loop",dayDetail)
              if (["Full Day"].includes(dayDetail.day)) {
                shouldIncludeDate = false;
              } else if (dayDetail.day === "Half Day-Morning" && selectedLeaveTypeValue === "FULL DAY") {
                effectiveLeaveType = "SECOND HALF";
              } else if (dayDetail.day === "Half Day-Evening" && selectedLeaveTypeValue === "FULL DAY") {
                effectiveLeaveType = "FIRST HALF";
              } else if (dayDetail.day === "Half Day-Morning" && selectedLeaveTypeValue === "FIRST HALF") {
                shouldIncludeDate = false;
              } else if (dayDetail.day === "Half Day-Evening" && selectedLeaveTypeValue === "SECOND HALF") {
                shouldIncludeDate = false;
              }
            }
          }
        }
      }

      // Add the date if it's valid
      if (shouldIncludeDate) {
        const dayValue = effectiveLeaveType === "FULL DAY" ? 1 : 0.5;
        
        daysArray.push({
          day: `Day ${dayCount}`,
          date: dateStr,
          leaveType: effectiveLeaveType,
          dayValue: dayValue,
        });
        
        leaveDaysArray.push({
          date: dateStr,
          Day: effectiveLeaveType,
          dayValue: dayValue,
        });
        
        dayCount++;
      }
      
      currentDate.setDate(currentDate.getDate() + 1);
    }

    console.log("Days Array",daysArray)
    // Check if we have any valid days
    if (daysArray.length === 0) {
      showNotification('warning', 'No Valid Days', 'The selected range contains only holidays, Sundays, or Saturdays (for Academic employees). Please select a different date range.');
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      setDateRange([]);
      setLeaveDays([]);
    } else {
      setDateRange(daysArray);
      setLeaveDays(leaveDaysArray);
    }
  }
  
  console.log("leaveDays after date click:", leaveDays);
};
const handleLeaveTypeChange = (index, selectedOption) => {
  if (maternityLeave) return;
  const dateStr = dateRange[index].date;
  
  // Get current user and employee type
  const user = JSON.parse(localStorage.getItem("user"));
  const isAcademic = employees.data?.find(emp => emp.user === user?.data._id)?.employee_type === "Academic";
  
  const matchingHolidays = holidays.filter(h =>
    h.daysDetail.some(d => formatDate(new Date(d.date)) === dateStr)
  );

  let isValid = true;
  for (const holiday of matchingHolidays) {
    // Check if holiday applies to current employee type
    const holidayAppliesToEmployee = 
      !holiday.holidayType || 
      holiday.holidayType === "Common" ||
      (holiday.holidayType === "Academic" && isAcademic) ||
      (holiday.holidayType === "Non-Academic" && !isAcademic);
      
    if (!holidayAppliesToEmployee) {
      continue; // Skip this holiday as it doesn't apply to current employee
    }

    for (const dayDetail of holiday.daysDetail) {
      if (formatDate(new Date(dayDetail.date)) === dateStr ) {

        if (["Full Day", "Flexible"].includes(dayDetail.day)) {
          isValid = false;
        } else if (dayDetail.day === "Half Day-Morning" && selectedOption.value === "FIRST HALF") {
          isValid = false;
        } else if (dayDetail.day === "Half Day-Evening" && selectedOption.value === "SECOND HALF") {
          isValid = false;
        }
      }
    }
  }

  if (!isValid) {
    showNotification('warning', 'Invalid Leave Type', `Cannot apply ${selectedOption.label} leave on ${dateStr} due to holiday conflict.`);
      return;
  }

  const updatedLeaveDays = [...leaveDays];
  updatedLeaveDays[index].Day = selectedOption.value;
  updatedLeaveDays[index].dayValue = selectedOption.dayValue;
  setDateRange(prev => {
    const updated = [...prev];
    updated[index].leaveType = selectedOption.value;
    return updated;
  });
  setLeaveDays(updatedLeaveDays);
  console.log("leaveDays after type change:", updatedLeaveDays);
};

  const handleLeaveTypeSelection = (selectedOption) => {
    setSelectedLeaveType(selectedOption);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setDateRange([]);
    setLeaveDays([]);
  };

  const calculateTotalLeaveDays = () => {
    return leaveDays.reduce((total, day) => total + (day.dayValue || 0), 0);
  };

  const handleStatusCheckboxChange = () => {
    setRegularLeave(true);
    setShortLeave(false);
    setDutyLeave(false);
    setSpecialLeave(false);
    setMaternityLeave(false);
    setExpectedDeliveryDate(null);
  };

  const handleCheckboxShortLeave = () => {
    setRegularLeave(false);
    setShortLeave(true);
    setDutyLeave(false);
    setSpecialLeave(false);
    setMaternityLeave(false);
    setExpectedDeliveryDate(null);
  };

  const handleCheckboxDutyLeave = () => {
    setRegularLeave(false);
    setShortLeave(false);
    setDutyLeave(true);
    setSpecialLeave(false);
    setMaternityLeave(false);
    setExpectedDeliveryDate(null);
  };

  const handleCheckboxSpecialLeave = () => {
    setRegularLeave(false);
    setShortLeave(false);
    setDutyLeave(false);
    setSpecialLeave(true);
    setMaternityLeave(false);
    setExpectedDeliveryDate(null);
  };

  const handleCheckboxMaternityLeave = () => {
    if (!isFemale) {

     showNotification('warning', 'Not Eligible', 'Only female employees can apply for maternity leave.');
      return;
    }
    setRegularLeave(false);
    setShortLeave(false);
    setDutyLeave(false);
    setSpecialLeave(false);
    setMaternityLeave(true);
  };

  const goToPreviousMonth = () => {
    if (viewMonth === 0) {
      setViewMonth(11);
      setViewYear(viewYear - 1);
    } else {
      setViewMonth(viewMonth - 1);
    }
  };

  const goToNextMonth = () => {
    if (viewMonth === 11) {
      setViewMonth(0);
      setViewYear(viewYear + 1);
    } else {
      setViewMonth(viewMonth + 1);
    }
  };

  const renderCalendar = () => {
    console.log("Render Calander")
    const daysInMonth = getDaysInMonth(viewMonth, viewYear);
    const firstDay = getFirstDayOfMonth(viewMonth, viewYear);
    const days = [];
    console.log("View Year and Moonth",viewYear,viewMonth)
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day"></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(viewYear, viewMonth, day);
      const selectedLeaveTypeValue = leaveDays.length > 0 ? leaveDays[0].Day : "FULL DAY";
      const isDisabled = isDateDisabled(date, selectedLeaveTypeValue);
      const isSelected = isSelectedDate(date);
      const isInRange = isDateInRange(date);
      const isToday = date.toDateString() === new Date().toDateString();

      days.push(
        <div
          key={day}
          className={`calendar-day ${isDisabled ? "disabled" : ""} 
                     ${isSelected ? "selected" : ""} 
                     ${isInRange ? "in-range" : ""} 
                     ${isToday ? "today" : ""}`}
          onClick={() => !isDisabled && handleDateClick(date)}
        >
          {day}
        </div>
      );
    }

    return days;
  };

  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["application/pdf", "image/jpeg", "image/png"];
      const maxSize = 5 * 1024 * 1024;
      if (!validTypes.includes(file.type)) {
     showNotification('warning', 'Invalid File Type', 'Only PDF, JPEG, and PNG files are allowed.');
        setDocumentFile(null);
        return;
      }
      if (file.size > maxSize) {
             showNotification('warning', 'File Too Large', 'File size must be less than 5MB.');

        setDocumentFile(null);
        return;
      }
      setDocumentFile(file);
    }
  };

useEffect(() => {
  if (dateRange.length > 0 && regularLeave && leaveDays.length !== dateRange.length) {
    const newLeaveDays = dateRange.map((item) => ({
      date: item.date,
      Day: item.leaveType,
      dayValue: leaveDayOptions.find(opt => opt.value === item.leaveType)?.dayValue || 1,
    }));
    setLeaveDays(newLeaveDays);
    console.log("Syncing leaveDays with dateRange:", newLeaveDays);
  }
}, [dateRange, regularLeave, leaveDayOptions.length]); // Use length to avoid object reference changes


const handleSubmit = async (e) => {
  e.preventDefault();
  if (isSubmitting) return;
  setIsSubmitting(true);
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
      showNotification('warning', 'Error', 'User data not found. Please log in again.');
      setIsSubmitting(false);
    return;
  }

  if (!maternityLeave && (!selectedStartDate || !selectedEndDate)) {
      showNotification('warning', 'Required Fields Missing', 'Please select both start and end dates.');
      setIsSubmitting(false);
    return;
  }

  if (maternityLeave && !expectedDeliveryDate) {
      showNotification('warning', 'Required Fields Missing', 'Please select the expected delivery date.');
      setIsSubmitting(false);
    return;
  }


  if (regularLeave && (!selectedLeaveType || leaveDays.length === 0)) {
      showNotification('warning', 'Required Fields Missing', 'Please select a leave type and specify leave days for all selected dates.');
      setIsSubmitting(false);
    return;
  }

  const coverupRequired = isDepartmentCoverupEnabled && !maternityLeave && !dutyLeave && !specialLeave && !shortLeave && selectedLeaveType?.label !== "Roster Leave";
  if (coverupRequired && !selectedCoverupEmployee) {
    showNotification('warning', 'Cover-up Required', 'Please select a cover-up employee to proceed.');
    setIsSubmitting(false);
    return;
  }

  if (shortLeave && !selectedTime) {
      showNotification('warning', 'Required Fields Missing', 'Please select a leave time for short leave.');
      setIsSubmitting(false);
    return;
  }

  if ((dutyLeave || specialLeave) && !reason) {
      showNotification('warning', 'Required Fields Missing', 'Please provide a reason for the leave.');
      setIsSubmitting(false);
    return;
  }

  const totalLeaveDays = calculateTotalLeaveDays();

  if (regularLeave && selectedLeaveType && totalLeaveDays > selectedLeaveType.leaveCount) {
      showNotification('warning', 'Invalid Leave Days', 'The total leave count cannot exceed the available leave balance.');
      setIsSubmitting(false);
    return;
  }

  const leaveData = {
    leavetype: regularLeave ? selectedLeaveType?.value : "",
    leaveTypeName: selectedLeaveType?.label || "",
    leaveDays: leaveDays.length > 0 ? leaveDays : dateRange.map((item) => ({
      date: item.date,
      Day: item.leaveType,
      dayValue: leaveDayOptions.find(opt => opt.value === item.leaveType)?.dayValue || 1,
    })),
    attendanceType: leaveDays.length > 0 ? leaveDays.map(day => day.Day) : null, // Use array of all attendance types
    reason: reason || "",
    startDate: formatDate(selectedStartDate),
    endDate: formatDate(selectedEndDate),
    approval: null,
    userId: user.data._id,
    name: user.data.name,
    duration: totalLeaveDays,
    shortLeave,
shortLeaveTime: shortLeave
    ? selectedTime?.value || ""
    : (dutyLeave || specialLeave)
    ? leaveDays.length > 0
      ? leaveDays[0].Day // Use the first leave day's type, or adjust if multiple days need different types
      : "FULL DAY" // Fallback if no leave days
    : "",    dutyLeave,
    specialLeave,
    maternityLeave,
    expectedDeliveryDate: expectedDeliveryDate ? formatDate(expectedDeliveryDate) : "",
    coverupEmployee: selectedCoverupEmployee?.value || "",
  };

  console.log("leaveData before submission:", leaveData);

  try {
    console.log("Submitting leaveData:", JSON.stringify(leaveData, null, 2));
    const response = await createLeaveEmployee(leaveData, documentFile);

    if (response.status === "success") {
      FetchLeaveEmployees();
      const successMessage = regularLeave
        ? `Leave applied successfully! Total leave days: ${response.data.totalLeaveDays}`
        : "Leave applied successfully!";

     
        showNotification('success', 'Leave Submitted', successMessage);
        resetForm();
        handleCancel();
        resetForm();
        handleCancel();
   
    } else {
             showNotification('error', 'Error', response.message || 'Failed to submit leave.');

    }
  } catch (error) {
    console.error("Failed to submit leave:", error);
         showNotification('error', 'Error', error.response?.data?.message || 'An error occurred while submitting the leave.');

  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div>
            {contextHolder}

      <div className="page-wrapper-new p-0">
        <div className="modal-content">
          <div className="modal-header border-0 custom-modal-header-leave">
            <h4>Apply Leave</h4>
          </div>
          <div className="modal-body custom-modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="mb-3">
                  <div className="button-container-app">
                    <div className={`tag-leave ${regularLeave ? "active" : ""}`} onClick={handleStatusCheckboxChange}>
                      Regular
                    </div>
              {isNonAcademicEmployee && (
                      <div className={`tag-leave ${shortLeave ? "active" : ""}`} onClick={handleCheckboxShortLeave}>
                        Short
                      </div>
                    )}
                    <div className={`tag-leave ${dutyLeave ? "active" : ""}`} onClick={handleCheckboxDutyLeave}>
                      Duty
                    </div>
                    <div className={`tag-leave ${specialLeave ? "active" : ""}`} onClick={handleCheckboxSpecialLeave}>
                      Special
                    </div>
                    {isFemale && (
                      <div className={`tag-leave ${maternityLeave ? "active" : ""}`} onClick={handleCheckboxMaternityLeave}>
                        Maternity
                      </div>
                    )}
                  </div>
                </div>

                {regularLeave && (
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">Select Leave Type</label>
                      <Select
                        className="select"
                        value={selectedLeaveType}
                        options={leaveType.filter(opt => opt.value !== "Choose")}
                        placeholder="Select leave type"
                        onChange={handleLeaveTypeSelection}
                      />
                    </div>
                  </div>
                )}

                <div className="col-lg-12">
                  {maternityLeave && (
                    <div className="mb-3 summer-description-box mb-0">
                      <label>Expected Delivery Date</label>
                    </div>
                  )}
                  <div className="input-blocks">
                    <div className="calendar-wrapper">
                      <div className="calendar-header">
                        <div className="calendar-month-year">
                          {months[viewMonth]} {viewYear}
                        </div>
                        <div className="calendar-nav">
                          <button type="button" onClick={goToPreviousMonth}>Previous</button>
                          <button type="button" onClick={goToNextMonth}>Next</button>
                        </div>
                      </div>
                      <div className="calendar-grid">
                        {weekdays.map(day => (
                          <div key={day} className="calendar-weekday">{day}</div>
                        ))}
                        {renderCalendar()}
                      </div>
                    </div>
                    {(selectedStartDate && selectedEndDate) && (
                      <div className="col-lg-12 mt-3">
                        <div className="mb-3">
                          <p>Start Date: {formatDate(selectedStartDate)}</p>
                          <p>End Date: {formatDate(selectedEndDate)}</p>
                          <p>Total Leave Days: {calculateTotalLeaveDays()}</p>
                        </div>
                      </div>
                    )}
                  </div>

                  {shortLeave && (
                    <div className="col-12">
                      <div className="input-blocks">
                        <label htmlFor="leaveTime">Leave Time</label>
                        <Select
                          value={selectedTime}
                          options={shortLeaveOptions}
                          className="select"
                          placeholder="Select time"
                          onChange={setSelectedTime}
                        />
                      </div>
                    </div>
                  )}
                </div>

                {!maternityLeave && dateRange.map((item, index) => (
                  <div key={index} className="col-lg-12">
                    <div className="apply-leave">
                      <div className="leave-apply">
                        <div className="leave-date">
                          <span>{item.day}</span>
                          <p>{item.date}</p>
                        </div>
                       {(!shortLeave || dutyLeave || specialLeave) && (
  <div className="leave-time">
    <div className="input-blocks mb-0">
      <Select
        className="select"
        options={leaveDayOptions}
        placeholder="Select Leave Day"
        value={leaveDayOptions.find(opt => opt.value === item.leaveType)}
        onChange={(option) => handleLeaveTypeChange(index, option)}
      />
    </div>
  </div>
)}
                      </div>
                    </div>
                  </div>
                ))}

                {!maternityLeave && !dutyLeave && !specialLeave && !shortLeave && selectedLeaveType?.label !== "Roster Leave" && isDepartmentCoverupEnabled && (
                  <div className="col-lg-12">
                    <div className="mb-3 summer-description-box mb-0">
                      <label>Cover-up Employee</label>
                      <Select
                        className="select"
                        value={selectedCoverupEmployee}
                        options={filteredEmployees.map(emp => ({
                          value: emp._id,
                          label: emp.full_name || `${emp.first_name} ${emp.last_name}`,
                        }))}
                        placeholder="Select Cover-up Employee"
                        onChange={setSelectedCoverupEmployee}
                        isClearable
                      />
                    </div>
                  </div>
                )}

                {(regularLeave || dutyLeave || specialLeave) && (
                  <div className="col-lg-12">
                    <div className="mb-3 summer-description-box mb-0">
                      <label>Reason</label>
                      <input
                        type="text"
                        value={reason}
                        className="form-control"
                        onChange={(e) => setReason(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                <div className="col-lg-12">
                  <div className="mb-3 summer-description-box mb-0">
                    <label className="form-label">Upload Supporting Document</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleDocumentChange}
                    />
                    {documentFile && <p className="mt-2">Selected file: {documentFile.name}</p>}
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <button type="button" className="btn btn-reset me-2" onClick={resetForm}>
                  Reset
                </button>
                <div className="page-btn">
                  <button type="submit" className="btn btn-submit" disabled={isSubmitting}>
                    {isSubmitting ? "Applying..." : "Apply Leaves"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

AddLeaveEmployee.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  FetchLeaveEmployees: PropTypes.func.isRequired,
};

export default AddLeaveEmployee;